$shm_showcase_demo_echarts $mol_list
	rows /
		<= Kind $mol_switch
			value? <=> kind? \bar
			options *
				bar \Столбцы
				line \Линия
		<= Plot $mol_view
			sub /
				<= Chart $shm_echarts
					option <= option null
